import { Icon, IconNames } from '@sendible/design-system/src';
import { normalisePlatform } from '@sendible/frontendv2/src/models/reporting/transforms';
import { ProfileIconsWrapper } from './index.styles';
import { PLATFORM_COLOR_ICON_MAP } from '../../helpers';

const ProfileIcons = ({
  isChartType,
  selectedProfiles,
  supportedPlatforms,
}: {
  isChartType?: boolean;
  selectedProfiles?: ReportProfile[];
  supportedPlatforms?: string[];
}) => {
  if (!selectedProfiles || selectedProfiles.length === 0) return null;

  // If supportedPlatforms is provided, filter profiles; otherwise show all profiles
  let uniquePlatforms: Set<string>;

  if (supportedPlatforms && supportedPlatforms.length > 0) {
    const normalisedSupported = new Set(supportedPlatforms.map(normalisePlatform));

    uniquePlatforms = new Set(
      selectedProfiles
        .filter((profile) => normalisedSupported.has(normalisePlatform(profile.platform)))
        .map((profile) => normalisePlatform(profile.platform))
    );
  } else {
    // If no supportedPlatforms, show all unique platforms from selectedProfiles
    uniquePlatforms = new Set(selectedProfiles.map((profile) => normalisePlatform(profile.platform)));
  }

  if (uniquePlatforms.size === 0) return null;

  return (
    <ProfileIconsWrapper $isChartType={isChartType}>
      {Array.from(uniquePlatforms).map((platform) => {
        const networkIcon = (PLATFORM_COLOR_ICON_MAP[platform] ?? 'user') as IconNames;

        return (
          <Icon
            key={platform}
            name={networkIcon}
          />
        );
      })}
    </ProfileIconsWrapper>
  );
};

export default ProfileIcons;
